import React, { Fragment, useContext, useEffect, useRef } from "react";
import "./LottieContent.css";
import lottie from "lottie-web";
import { useNavigate } from "react-router-dom";
import Lottie_Driver from "../../../Assets/lottie/Lottie_Driver.json";
import RegistrationForm from "../PopUpWindow/RegistrationForm/RegistrationForm";
import { DownloadContext } from "../../../context/DownloadContextProvider";
import { FooterContext } from "../../../context/FooterContextProvider";
import { BookingFlowParaContext } from "../../../context/BookingFlowParaProvider";
import ReactGA from "react-ga4";
import { GENEREATE_LINK } from "../../../Constants";

function LottieContent() {
  const navigate = useNavigate();
  const animationRef = useRef(null);
  const { showPopUp, setShowPopUp, handleScroll } = useContext(DownloadContext);
  const { navbarRef } = useContext(FooterContext);
  const { isAuthenticated } = useContext(BookingFlowParaContext);

  const handleAppDownload = ()=>{
    ReactGA.gtag("event", "hp_download_app", {
      event_category: "button", 
      event_label: "Home_Page_UI",
      value: 1,
      position: "top",
      destination: "generic_download",
    });
    window.location.href = GENEREATE_LINK;
  };

  
  const handleBookDriver = () => {
    ReactGA.event({
      category: " button",
      action:"Book_Driver_Top_Button_Click",
      label: "Home_Page_UI",
      value: 1
    });
    if (isAuthenticated === true) {
      navigate("/book-driver/");
    } else if (isAuthenticated === false) {
      setShowPopUp(true);
    }
  };
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: Lottie_Driver,
    });
    return () => anim.destroy();
  }, []);
  useEffect(() => {
    if (showPopUp) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "scroll";
    };
  }, [showPopUp]);
  return (
    <Fragment>
      <div className="container" ref={navbarRef}>
        <div className="wrapper-content-lottie">
          <div className="wrapper-content">
            <div className="content_hire">
              <div className="content_subsection">SIMPLIFY CAR OWNERSHIP</div>
              <h1 className="content_section_heading">
                Hire professional drivers, and all car services at your
                fingertips.
              </h1>
              <div className="content_subsection_heading">
                Get rewarded for owning a car!
              </div>
              <div className="btn_download_bookDriver">
                <button onClick={handleBookDriver} className="book_driver">
                  Book Driver
                </button>
                <button className="download_app" onClick={handleScroll}>
                  Download App
                </button>
              </div>
            </div>
          </div>
          <div className="wrapper-lottie">
            <div
              className="content_lottie"
              id="content_lottie"
              ref={animationRef}
            />
            <div className="btn-app-download-mobile">
              <button onClick={handleBookDriver} className="book_now_mobile">
                Book Now
              </button>
              <button className="download_app_mobile" onClick = {handleAppDownload}>
                {/* <a
                  href={window.generatedLink}
                  style={{
                    textDecoration: "none",
                    color: "#09081a",
                  }}
                >
                  Download App
                </a> */}

                  Download App  
              </button>
            </div>
          </div>
        </div>
      </div>
      <>
        {showPopUp ? <div className="overlay" /> : null}
        {showPopUp ? <RegistrationForm className="form_number" /> : null}
      </>
    </Fragment>
  );
}

export default LottieContent;
